import React from 'react';
import { useDispatch } from 'react-redux';

import { displayView } from 'constants/UI';
import { setGridView } from 'actions/UI';
import { GridModalTrigger } from 'containers/Forms/GridModal';

import StyledButton from './StyledButton';

type Props = {
  title: string;
  height?: number;
  view: typeof displayView[keyof typeof displayView];
  removeMargin?: boolean;
};

const PopupButton: React.FC<Props> = ({
  title,
  height = 65,
  view,
  removeMargin,
}) => {
  const dispatch = useDispatch();
  return (
    <GridModalTrigger title={title}>
      <StyledButton
        height={height}
        buttonColor="grid_light"
        width="100%"
        removeMargin={removeMargin}
        onClick={() => dispatch(setGridView(view))}
      >
        {title}
      </StyledButton>
    </GridModalTrigger>
  );
};

export default PopupButton;
